import apiClient from "../../../api/apiClient";

/**
 * Fetch all leads from the backend
 */
export const fetchLeads = async () => {
  try {
    const response = await apiClient.get("/leads");
    console.log("fetch leads",response);
    return response.data;
  } catch (error) {
    console.error("Error fetching leads:", error);
    throw new Error("Failed to fetch leads. Please try again.");
  }
};

/**
 * Fetch a single lead by ID
 */
export const fetchLeadById = async (leadId) => {
  try {
    const response = await apiClient.get(`/leads/${leadId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching lead ${leadId}:`, error);
    throw new Error(`Failed to fetch lead ${leadId}. Please try again.`);
  }
};

/**
 * Bulk submit leads after preview
 */
export const bulkSubmitLeads = async (leads) => {
  try {
    const response = await apiClient.post("/leads/bulk-submit", { leads });
    return response.data;
  } catch (error) {
    console.error("Error submitting leads:", error);
    throw new Error("Failed to submit leads. Please try again.");
  }
};
/**
 * Bulk create leads by uploading an Excel file
 */
export const bulkCreateLeads = async (file) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await apiClient.post("/leads/bulk-upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("✅ API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error uploading leads:", error);
    throw new Error("Failed to upload leads. Please try again.");
  }
};
/**
 * Create a new lead
 */
export const createLead = async (leadData) => {
  try {
    const response = await apiClient.post("/leads", leadData);
    return response.data;
  } catch (error) {
    console.error("Error creating lead:", error);
    throw new Error("Failed to create lead. Please try again.");
  }
};

/**
 * Update an existing lead
 */
export const updateLead = async (leadId, leadData) => {
  try {
    const response = await apiClient.put(`/leads/${leadId}`, leadData);
    return response.data;
  } catch (error) {
    console.error(`Error updating lead ${leadId}:`, error);
    throw new Error(`Failed to update lead ${leadId}. Please try again.`);
  }
};

/**
 * Delete a lead
 */
export const deleteLead = async (leadId) => {
  try {
    const response = await apiClient.delete(`/leads/${leadId}`);
    return response.data || { message: "Lead deleted successfully" };
  } catch (error) {
    console.error(`Error deleting lead ${leadId}:`, error);
    throw new Error(`Failed to delete lead ${leadId}. Please try again.`);
  }
};